<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { getAccountMapOverlays } from '@gpx-spa/queries';
import { setTitle } from '@/utils/title';
import ThreeColumnLayout from '@/components/_common/ThreeColumnLayout.vue';
import CommonSearch from '@/components/_common/CommonSearch.vue';
import { topBarInsetClass } from '@/components/_common/navbar/topBarInset';
import MapControlPanel from '@/components/_common/navbar/MapControlPanel.vue';
import OverlayList from '@/components/overlay/OverlayList.vue';
import OverlayMap from '@/components/overlay/OverlayMap.vue';

import { useSynchronizedSidebars } from '@/composables/useSynchronizedSidebars';
useSynchronizedSidebars();

import { useResetChatOnSidebarClose } from '@/composables/useResetChatOnSidebarClose';
useResetChatOnSidebarClose();

import { useResetChatOnAccountOrUserChange } from '@/composables/useResetChatOnAccountOrUserChange';
useResetChatOnAccountOrUserChange();

const store = useStore();
const accountId = computed(() => store.getters['auth/accountId']);
const selectedOverlayId = ref(null);

const { data: overlaysData } = getAccountMapOverlays(accountId);

const overlays = computed(() => overlaysData.value || []);

setTitle('Map Overlays');
</script>

<template>
  <ThreeColumnLayout>
    <template #leftTop>
      <div :class="topBarInsetClass">
        <CommonSearch placeholder="Search Overlays..." />
      </div>
    </template>
    <template #left>
      <OverlayList
        :overlays="overlays"
        :selectedOverlayId="selectedOverlayId"
        @select="selectedOverlayId = $event"
      />
    </template>
    <template #rightTop>
      <MapControlPanel />
    </template>
    <template #right>
      <OverlayMap :overlays="overlays" :focusOverlayId="selectedOverlayId" />
    </template>
  </ThreeColumnLayout>
</template>
